import { ErrorType } from '../../errors-handler/ErrorsHandler.types';
import { extractErrorEventInfo } from '../ErrorViews.utils';

const BLOCKED_DOMAINS = ['amplitude.com', 'tag-manager.photosi.com', 'bat.bing.com'];

export const isThirdPartyNetworkError = ({ event }: ErrorType) => {
  const { message, src } = extractErrorEventInfo(event);
  return BLOCKED_DOMAINS.some(domain => message.includes(domain) || (src ?? '').includes(domain));
};
